import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout>
      <h1>Política de privacidad</h1>
      <p className="legalUpdated">Última actualización: septiembre de 2026</p>

      <p>
        Magec es una app de gestión de tareas y calendario para equipos de
        trabajo. El acceso se realiza con la cuenta que te proporciona tu
        organización.
      </p>

      <h2>Qué datos tratamos</h2>
      <ul>
        <li>
          <strong>Datos de acceso:</strong> las credenciales que la empresa
          te proporciona para iniciar sesión.
        </li>
        <li>
          <strong>Datos de trabajo:</strong> las tareas, horarios y tiempos
          que registras dentro de la app, asociados a tu cuenta.
        </li>
        <li>
          <strong>Token de notificaciones push:</strong> un identificador
          técnico de tu dispositivo, usado únicamente para poder enviarte
          notificaciones relacionadas con tus tareas.
        </li>
      </ul>
      <p>
        No recolectamos datos de navegación, publicidad, ni información de
        dispositivos ajena al funcionamiento de la app.
      </p>

      <h2>Con quién compartimos datos</h2>
      <p>
        Usamos Firebase Cloud Messaging (Google) exclusivamente para
        entregar notificaciones push a tu dispositivo. No compartimos tus
        datos con terceros con fines comerciales ni publicitarios.
      </p>

      <h2>Cuánto tiempo se conservan</h2>
      <p>
        Los datos se conservan mientras tu cuenta tenga acceso activo a la
        app. El token de notificaciones se elimina automáticamente si deja
        de ser válido (por ejemplo, al desinstalar la app).
      </p>

      <h2>Tus derechos</h2>
      <p>
        Puedes solicitar acceso, corrección o eliminación de tus datos
        contactando a{" "}
        <a href="mailto:imetropolis@metropoliscom.com">
          imetropolis@metropoliscom.com
        </a>
        .
      </p>
    </LegalLayout>
  );
}
